import {styled} from '@mui/system'

// NOTE: dimensions are fixed px values (not theme.spacing(n)) on purpose.
// This component is shared by legacy pages and new-style pages, whose themes
// use different spacing base units (legacy: 2, new: 8). Using theme.spacing(n)
// made the button balloon to ~4x its intended size when rendered inside
// ThemeProviderNew (e.g. the "Cerca" button in the "Lista pazienti" filter).
export const PrimaryButtonStyled = styled('div')(({theme}) => ({
  '.MuiButtonBase-root': {
    color: 'white',
    borderRadius: 42,
    height: 42,
    minWidth: 36,
    padding: '0 30px',
    fontSize: 14,
    fontWeight: '600',
    textTransform: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme.palette.primary[100]
    }
  }
}))
